"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/~/babel-runtime/helpers/classCallCheck.js
// module id = ./node_modules/gatsby-link/node_modules/babel-runtime/helpers/classCallCheck.js
// module chunks = 168707334958949